import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bulk-english-test',
  templateUrl: './bulk-english-test.component.html',
  styleUrls: ['./bulk-english-test.component.scss']
})
export class BulkEnglishTestComponent implements OnInit {

  appStatusEnglishTest: any = 30;
  showLoader: boolean = false;
  creating: boolean = false;
  englishReportFile: any;
  englishReportFileName: any;
  displayData = "";

  bulkEnglishTestForm = new FormGroup({
    // bulkSheet: new FormControl('', [
    //   Validators.required,
    // ])
  });


  constructor(private admService: AdmService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService,
    public activatedRoute: ActivatedRoute, public router: Router,
    public translate: TranslateService) { }

  ngOnInit(): void { }

  bulkEnglishTestFormSubmit() {
    if (this.bulkEnglishTestForm.valid) {
      this.creating = true;
      this.loadDataFromBackend();
    }
    else {
      console.log("non valid");
      this.bulkEnglishTestForm.markAllAsTouched();
      this.bulkEnglishTestForm.markAsDirty();
      this.creating = false;
    }
  }

  bulkEnglishTestFormChange() {

  }

  changeFile(event: any) {
    let typesAccept = ['application/pdf'];
    // Max size 200 MEGA
    let maxSize = 209715200;
    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        this.englishReportFile = event.target.files[0];
        return true;
      } else {
        this.bulkEnglishTestForm.controls.englishReport.reset();
        this.bulkEnglishTestForm.controls.englishReport.markAsDirty();
        this.bulkEnglishTestForm.controls.englishReport.markAsTouched();

        if (currentFile.size > maxSize) {
          this.toastr.error(this.translate.instant("MAX_FILE_SIZE_200_MB"))
        }
        return false;
      }
    } else {
      return false;
    }
  }

  handleUploadFiles() {
    let formData = new FormData();

    let fname = this.englishReportFile.name.split('.').slice(0, -1).join('.')
    let fext = this.englishReportFile.name.split('.').pop()
    this.englishReportFileName = fname + "_" + Date.now() + "." + fext
    formData.append('file', this.englishReportFile, this.englishReportFileName);

    console.log("file name : " + this.englishReportFileName);


    // this.fileService.uploadFile(formData).subscribe(
    //   data => {
    //   },
    //   error => {
    //     this.creating = false
    //     this.toastr.warning(this.translate.instant("CAN_NOT_UPLOAD_FILES"));
    //   }
    // );
  }

  loadDataFromBackend() {
    let username = this.globals.currentUserInfo.username;
    this.admService.admLoadLangFomInterface(username).subscribe(
      data => {
        this.displayData = data[0];
      },
      error => {
        this.creating = false
        this.toastr.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
}
